// extracted by mini-css-extract-plugin
export var Anchor = "Anchor-module--Anchor--43bed";